import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const InsertPluginIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ viewBox: "0 0 19 19", width: "19", height: "19" }, props), /* @__PURE__ */ React.createElement("path", { d: "M4.889 5L1 8.89l3.889 3.888.707-.708-3.182-3.18 3.182-3.184zm8.818 7.779l3.89-3.89L13.706 5 13 5.708l3.182 3.181L13 12.072z" }), /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", d: "M11.948 2L7 15.978" }));

export { InsertPluginIcon as default };
//# sourceMappingURL=InsertPluginIcon.js.map
